import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(singleColumnLayout)/search-results/[searchIndex]/[search]/Search.js");
